// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"6ede9426","923":"ec16cbdb","933":"e249e80b","982":"ec16cbdb"}[chunkId] + ".chunk.css";
};